const { VUE_APP_API_URL: RUTA_GLOBAL } = process.env

// Abort a fetch after this many milliseconds so a stalled PHP-FPM worker
// never freezes the router guard (beforeEach awaits these calls).
const TIMEOUT_MS = 15000

function fetchConTimeout(url, opciones) {
	const controller = new AbortController()
	const timer = setTimeout(() => controller.abort(), TIMEOUT_MS)
	return fetch(url, { ...opciones, signal: controller.signal })
		.finally(() => clearTimeout(timer))
}

/**
 * Error de transporte: permite distinguir "no llegó" de "no se pudo confirmar".
 * tipo: 'timeout' | 'red' | 'respuesta'
 */
class ErrorHttp extends Error {
	constructor(mensaje, tipo, estado = null) {
		super(mensaje)
		this.name = 'ErrorHttp'
		this.tipo = tipo
		this.estado = estado
	}
}

/**
 * Ejecuta la petición y normaliza los fallos de transporte, para que los formularios
 * puedan mostrar un mensaje útil en vez de quedarse colgados sin explicación.
 *
 * NO se reintenta nada automáticamente: las escrituras del API (ventas, abonos, cuentas)
 * no son idempotentes, y un reintento automático crearía documentos duplicados. El
 * reintento lo decide el usuario, reusando la misma clave de idempotencia.
 *
 * El estado HTTP no se convierte en excepción (se devuelve el cuerpo tal cual, como antes):
 * así no cambia el comportamiento de las pantallas que ya leen respuestas de error del API.
 */
async function pedir(url, opciones) {
	let respuesta

	try {
		respuesta = await fetchConTimeout(url, { credentials: 'include', ...opciones })
	} catch (error) {
		if (error && error.name === 'AbortError') {
			throw new ErrorHttp(
				`La solicitud tardó más de ${TIMEOUT_MS / 1000} s. No se pudo confirmar si se guardó: revisa la lista antes de repetir.`,
				'timeout'
			)
		}

		throw new ErrorHttp('No hay conexión con el servidor. Revisa tu internet.', 'red')
	}

	try {
		return await respuesta.json()
	} catch (error) {
		throw new ErrorHttp('La respuesta del servidor no se pudo interpretar.', 'respuesta', respuesta.status)
	}
}

const HttpService =  {
	async registrar(ruta, datos) {
		return pedir(`${RUTA_GLOBAL}/${ruta}`, {
			method: "post",
			body: JSON.stringify(datos),
		})
	},

	async obtener(ruta) {
		return pedir(`${RUTA_GLOBAL}/${ruta}`, { method: "get" })
	},

	async editar(ruta, datos) {
		return pedir(`${RUTA_GLOBAL}/${ruta}`, {
			method: "post",
			body: JSON.stringify(datos),
		})
	},

	async eliminar(ruta, datos) {
		return pedir(`${RUTA_GLOBAL}/${ruta}`, {
			method: "post",
			body: JSON.stringify(datos),
		})
	},

	async obtenerConConsultas(ruta, payload){
		// Sigue siendo POST: el API lee el payload del cuerpo, no de la query string.
		return pedir(`${RUTA_GLOBAL}/${ruta}`, {
			method: "post",
			body: JSON.stringify(payload),
		})
	},
}

export default HttpService
